<template>
  <main class="auth" v-loading="true">
    <template v-if="isVisible">
      <div v-if="!!initData">
        Auth is in progress... Reopen app if you still see this
      </div>
      <div v-else> Runs only as Telegram Mini App</div>
    </template>
  </main>
</template>

<script setup lang="ts">
import { authService } from '@/services/auth.service'
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter()
const initData = window.Telegram.WebApp.initData

const login = async () => {
  const isSuccess = await authService.login(initData)

  if (isSuccess) {
    router.push({
      name: 'tap'
    })
  }
}

login()

const isVisible = ref(false)
onMounted(() => {
  setTimeout(() => {
    isVisible.value = true
  }, 2000)
})

</script>


<style lang="scss" scoped>
.auth {
  padding: 10em 5em;
  height: 100vh;
}
</style>